<ng-container *transloco="let t">
  <div class="cdv-finding" [formGroup]="form">
    <div class="field">
      <label class="label">{{ t('CDV Test Title') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="cdvTest" rows="4"></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('CDV Note') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="note" rows="4"></textarea>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
